import { render, staticRenderFns } from "./ccm-matchpaper-study.vue?vue&type=template&id=e70160ce&"
import script from "./ccm-matchpaper-study.vue?vue&type=script&lang=js&"
export * from "./ccm-matchpaper-study.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports